import { DateInput, TextInput } from 'framework/form';
import { Box, Grid2 as Grid } from '@mui/material';
import { InvoiceTotalInput } from 'domain/shared/core/invoice';
import { BillingChangeRequestItem, CustomPeriod } from '../../types';
import {
  isBillingScheduleItemFullyLocked,
  isBillingScheduleItemStructureLocked,
} from '../../helpers/projectBillingHelper';

const isChangeRequestItem = (value?: CustomPeriod | BillingChangeRequestItem): value is BillingChangeRequestItem =>
  value?.itemType === 'CHANGE_REQUEST';

const formatChangeRequestAlias = (changeRequestAlias?: string) =>
  changeRequestAlias ? `Change Request ${changeRequestAlias}` : '';

const BillingProjectPeriodicCustom = ({
  source,
  index = 0,
  value,
}: {
  source: string;
  index?: number;
  value?: CustomPeriod | BillingChangeRequestItem;
}) => {
  const isFullyLocked = isBillingScheduleItemFullyLocked(value);
  const isStructureLocked = isBillingScheduleItemStructureLocked(value);

  if (isChangeRequestItem(value)) {
    return (
      <Grid container width="100%" columnSpacing="60px">
        <Grid size={5} display="flex" alignItems="flex-start" justifyContent="flex-start">
          <Box
            sx={{
              padding: '7px',
              border: '1px solid var(--mui-palette-border-default)',
              borderRadius: '3px',
              backgroundColor: 'var(--mui-palette-background-default)',
              color: 'var(--mui-palette-text-secondary)',
              mr: '5px',
            }}
          >
            {value?.changeRequestAlias || `CR${index + 1}`}
          </Box>
          <TextInput
            disabled
            label="Change request"
            source={`${source}.changeRequestAlias`}
            value={formatChangeRequestAlias(value?.changeRequestAlias)}
          />
        </Grid>

        <Grid size={3}>
          <InvoiceTotalInput disabled source={`${source}.amount`} currencySource="currency" label="Amount" />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container width="100%" columnSpacing="60px">
      <Grid size={3} display="flex" alignItems="flex-start" justifyContent="flex-start">
        <Box
          sx={{
            padding: '7px',
            border: '1px solid var(--mui-palette-border-default)',
            borderRadius: '3px',
            backgroundColor: 'var(--mui-palette-background-default)',
            color: 'var(--mui-palette-text-secondary)',
            mr: '5px',
          }}
        >
          {index + 1}
        </Box>
        <DateInput disabled={isStructureLocked} label="Start date" source={`${source}.startDate`} />
      </Grid>

      <Grid size={3}>
        <DateInput disabled={isStructureLocked} label="End date" source={`${source}.endDate`} />
      </Grid>

      <Grid size={3}>
        <DateInput disabled={isFullyLocked} label="Initial request deadline" source={`${source}.invoiceDate`} />
      </Grid>

      <Grid size={3}>
        <InvoiceTotalInput
          disabled={isFullyLocked}
          source={`${source}.amount`}
          currencySource="currency"
          label="Amount"
        />
      </Grid>
    </Grid>
  );
};

export default BillingProjectPeriodicCustom;
